import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";
import { RequestAccessButton } from "./RequestAccessButton";

export const AnalyticsCta = ({ className }) => (
    <div className={cn("mx-auto flex w-full max-w-[800px] flex-col items-center gap-5 text-center", className)}>
        <div className="flex flex-col items-center gap-2">
            <h2 className="text-xl font-medium text-cm-p-text-primary">
                <TranslatedText>CargoMinds Analytics</TranslatedText>
            </h2>
            <p className="max-w-[600px] text-sm text-cm-p-text-secondary">
                <TranslatedText>Get a complete view of your company’s performance with real-time analytics.</TranslatedText>
                <br className="hidden sm:block" />{" "}
                <TranslatedText>
                    Identify your strongest weeks and months, analyze what worked, and benchmark your success against industry averages and
                    top-performing companies.
                </TranslatedText>
            </p>
        </div>
        <RequestAccessButton />
    </div>
);
